// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"599c47f2","787":"a5a0ce24"}[chunkId] + ".chunk.js";
};